import { Action, createReducer, on } from '@ngrx/store';
import { changeMode, changeCardLayout, changeLayoutWidth, changeLayoutPosition, changeTopbar, changeTopbarImage, changeDataPreloader, changelayoutTheme, changeSidebarColor, changeSidebarSize } from "./layout-action";
import { LAYOUT_MODE_TYPES, DATA_CARD_LAYOUT_TYPES, LAYOUT_WIDTH_TYPES, LAYOUT_POSITION_TYPES, LAYOUT_TOPBAR_COLOR_TYPES, LEFT_TOPBAR_IMAGE_TYPES, PERLOADER_TYPES, LAYOUT_TYPES, LAYOUT_SIDEBAR, LEFT_SIDEBAR_SIZE } from './layout';

export interface LayoutState {
    LAYOUT_THEME: string;
    LAYOUT_MODE: string;
    CARD_LAYOUT: string;
    LAYOUT_WIDTH: string;
    LAYOUT_POSITION: string;
    TOPBAR: string;
    SIDEBAR_COLOR: string;
    SIDEBAR_SIZE: string;
    TOPBAR_IMAGE: string;
    DATA_PRELOADER: string;
}

// IntialState
export const initialState: LayoutState = {
    LAYOUT_THEME: LAYOUT_TYPES.VERTICAL,
    LAYOUT_MODE: LAYOUT_MODE_TYPES.LIGHTMODE,
    CARD_LAYOUT: DATA_CARD_LAYOUT_TYPES.BORDERLESS,
    LAYOUT_WIDTH: LAYOUT_WIDTH_TYPES.FLUID,
    LAYOUT_POSITION: LAYOUT_POSITION_TYPES.FIXED,
    TOPBAR: LAYOUT_TOPBAR_COLOR_TYPES.DARK,
    SIDEBAR_COLOR: LAYOUT_SIDEBAR.DARK,
    SIDEBAR_SIZE: LEFT_SIDEBAR_SIZE.LARGE,
    TOPBAR_IMAGE: LEFT_TOPBAR_IMAGE_TYPES.THREE,
    DATA_PRELOADER: PERLOADER_TYPES.DISABLE
}

// Reducer
export const layoutReducer = createReducer(
    initialState,
    on(changelayoutTheme, (state, action) => ({ ...state, LAYOUT_THEME: action.layout })),
    on(changeMode, (state, action) => ({ ...state, LAYOUT_MODE: action.mode })),
    on(changeCardLayout, (state, action) => ({ ...state, CARD_LAYOUT: action.cardLayout })),
    on(changeLayoutWidth, (state, action) => ({ ...state, LAYOUT_WIDTH: action.layoutWidth })),
    on(changeLayoutPosition, (state, action) => ({ ...state, LAYOUT_POSITION: action.layoutPosition })),
    on(changeTopbar, (state, action) => ({ ...state, TOPBAR: action.topbarColor })),
    on(changeTopbarImage, (state, action) => ({ ...state, TOPBAR_IMAGE: action.topbarImage })),
    on(changeDataPreloader, (state, action) => ({ ...state, DATA_PRELOADER: action.Preloader })),
    on(changeSidebarColor, (state, action) => ({ ...state, SIDEBAR_COLOR: action.sidebarColor })),
    on(changeSidebarSize, (state, action) => ({ ...state, SIDEBAR_SIZE: action.sidebarSize }))
);

// Selector
export function reducer(state: LayoutState | undefined, action: Action) {
    return layoutReducer(state, action);
}
